<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Table } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<Table>
	}

	let { blok }: Props = $props()

	const cells = $derived(blok.cells ?? { thead: [], tbody: [] })
</script>

<section class="table {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		<table class:alt={!blok.header && !blok.footer}>
			{#if blok.header}
				<thead>
					<tr>
						{#each cells.thead as { value }, i (i)}
							<th>{value}</th>
						{/each}
					</tr>
				</thead>
			{/if}
			<tbody>
				{#if !blok.header}
					<tr>
						{#each cells.thead as { value }, i (i)}
							<td>{value}</td>
						{/each}
					</tr>
				{/if}
				{#each cells.tbody.slice(0, blok.footer ? -1 : undefined) as { body }, i (i)}
					<tr>
						{#each body as { value }, i (i)}
							<td>{value}</td>
						{/each}
					</tr>
				{/each}
			</tbody>
			{#if blok.footer}
				<tfoot>
					<tr>
						{#each cells.tbody[cells.tbody.length - 1]?.body as { value }, i (i)}
							<th>{value}</th>
						{/each}
					</tr>
				</tfoot>
			{/if}
		</table>
	</div>
</section>

<style lang="css">
	.table {
		overflow: hidden;
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.contain {
		overflow: auto;
	}

	table {
		background-color: var(--c-gimson);
		font: 500 var(--f-body2);
		letter-spacing: var(--ls-body2);
		width: 100%;

		&.alt tr:nth-child(even) td {
			background-color: var(--c-gimson);
		}
	}

	th {
		font: inherit;
		padding: 0.75rem 1rem;
		text-align: start;
		white-space: nowrap;

		@media (--from-mobile) {
			padding: 1rem 1.75rem;
		}
	}

	td {
		background-color: var(--c-white);
		border: 1px solid var(--c-gimson);
		padding: 0.75rem 1rem;

		@media (--from-mobile) {
			padding: 1rem 1.75rem;
		}
	}
</style>
